module.exports = __webpack_public_path__ + "img/800m.0ad079fe.png";